import type {
  ComponentType,
} from 'react';
import type {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import CCMIcon from 'core/icons/CCMIcon';
import RTMIcon from 'core/icons/RTMIcon';
import TempoIcon from 'core/icons/TempoIcon';

export type PCCProgramKey = 'ccm' | 'tempo' | 'rtm';

export const PCC_PROGRAM_ICONS: Record<PCCProgramKey, ComponentType<SvgIconProps>> = {
  ccm: CCMIcon,
  tempo: TempoIcon,
  rtm: RTMIcon,
};
